import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import Tooltip from "@material-ui/core/Tooltip";

import AddCircleIcon from "@material-ui/icons/AddCircle";

import { useStyles } from "../../../../../Components/CSS/TableStyle.css";

class StudentMarksBody extends Component {
  render() {
    const { classes, student, index } = this.props;
    return (
      <TableRow>
        <TableCell align="center">{index + 1}</TableCell>
        <TableCell align="center">
          {student.firstName} {student.middleName} {student.lastName}
        </TableCell>
        <TableCell align="center">{student.studentClass}</TableCell>
        <TableCell align="center">
          {student.faculty ? student.faculty : "N/A"}
        </TableCell>
        <TableCell align="center">
          {student.group ? student.group : "N/A"}
        </TableCell>
        <TableCell align="center">{student.section}</TableCell>
        <TableCell align="center">
          <Tooltip
            title="Add Marks"
            className={classes.tooltip}
            onClick={() => this.props.handleDetailStatus(student)}
          >
            <AddCircleIcon />
          </Tooltip>
        </TableCell>
      </TableRow>
    );
  }
}

export default withStyles(useStyles)(StudentMarksBody);
